"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrackPcaInTimeRange = exports.getTrackPca = exports.TrackPca = void 0;
var Position_1 = require("../../DataModel/Common/Position");
var Track_1 = require("../../DataModel/Flight/Track");
var TrackExtensions_1 = require("../../Logic/Flight/TrackExtensions");
var Math3D = __importStar(require("../../Spatial/Math3D"));
var Projection_1 = require("../../Spatial/Projection");
var Vector3_1 = require("../../Spatial/Vector3");
/** Represents a point of closest approach from a geographic position to a track. */
var TrackPca = /** @class */ (function () {
    function TrackPca() {
    }
    return TrackPca;
}());
exports.TrackPca = TrackPca;
/**
 * Gets the Point of Closest Approach for a track to a reference point.
 * @param referencePoint - The reference point from which to calculate the Point of Closest Approach.
 * @param track - The track for which to calculate the Point of Closest Approach.
 * @returns - Returns a filled in TrackPca object for the Point of Closest Approach, or null if the track has no points.
 */
function getTrackPca(referencePoint, track) {
    if (track.points.length == 0) {
        return null;
    }
    // Turn the track into a series of Vector3[] values.
    var points = track.points.map(function (p) { return Projection_1.Projection.current.toLocalCoordinates(new Position_1.Position(p.lat, p.lon, p.alt)); });
    // Find the index of the closest point on the track polyline to the reference point
    var referenceVector = Projection_1.Projection.current.toLocalCoordinates(referencePoint);
    var closestPointIndex = getClosestPointToPoint(points, referenceVector);
    // And turn the index back into a track point
    var closestTrackPoint = TrackExtensions_1.getTrackPointAtIndex(track, closestPointIndex);
    // And find the local coordinate delta so we can use this in the returned value
    var closestLocalPoint = getPointAt(points, closestPointIndex);
    return makeTrackPcaFromLocalPoints(track, closestTrackPoint, closestLocalPoint, closestPointIndex, referencePoint, referenceVector);
}
exports.getTrackPca = getTrackPca;
/**
 * Gets the Point of Closest Approach for a track to a reference point, analysing only a section of track between two times.
 * @param referencePoint - The reference point from which to calculate the Point of Closest Approach.
 * @param track - The track for which to calculate the Point of Closest Approach.
 * @param startTime - The start time of the time range to analyse.
 * @param endTime - The end time of the time range to analyse.
 * @returns - Returns a filled in TrackPca object for the Point of Closest Approach, or null if the track doesn't cross the supplied time range, or has no points.
 */
function getTrackPcaInTimeRange(referencePoint, track, startTime, endTime) {
    if (endTime.getTime() < track.startTime.getTime() ||
        startTime.getTime() > track.startTime.getTime() + track.points[track.points.length - 1].t * 1000) {
        return null;
    }
    // Split the track up to only use points that lie between the start and end times
    var subTrack = new Track_1.Track();
    subTrack.id = track.id;
    subTrack.startTime = track.startTime;
    // We do the PCA across the whole track points on or slightly before start/end time - so we may take
    // slightly more points than required.
    // .
    // *-----*------*------*-----*------*        <-- This is the track
    //           ^            ^                  <-- These are the start and end times
    //       |-------------------|               <-- This is the track we extract, rounding down firstIndex, and up lastIndex.
    // Get the index of the track point at the start time, and round down to the nearest whole point index.
    var trackPointIndex = TrackExtensions_1.getTrackPointAtTime(track, startTime);
    var firstIndex = Math.floor(trackPointIndex.index);
    // Get the index of the track point at the end time, and round up to the nearest whole point index.
    trackPointIndex = TrackExtensions_1.getTrackPointAtTime(track, endTime);
    var lastIndex = Math.ceil(trackPointIndex.index);
    // Extract the original track points to be only the provided range (add 1 to make sure we include lastIndex as well).
    subTrack.points = track.points.slice(firstIndex, lastIndex + 1);
    // Do the PCA, and offset the TrackPointIndex by firstIndex to re-base it in the original track's indexes.
    var trackPca = getTrackPca(referencePoint, subTrack);
    if (trackPca == null)
        return null;
    trackPca.trackPointIndex += firstIndex;
    if (trackPca.time < startTime) {
        // Clamp to be equal to startTime
        trackPointIndex = TrackExtensions_1.getTrackPointAtTime(track, startTime);
        return makeTrackPca(track, trackPointIndex.point, trackPointIndex.index, referencePoint);
    }
    else if (trackPca.time > endTime) {
        // Clamp to be equal to endTime
        trackPointIndex = TrackExtensions_1.getTrackPointAtTime(track, endTime);
        return makeTrackPca(track, trackPointIndex.point, trackPointIndex.index, referencePoint);
    }
    return trackPca;
}
exports.getTrackPcaInTimeRange = getTrackPcaInTimeRange;
/**
 * Creates a track pca object from a track, track point, point index and reference point.
 * Call this method when you don't know the local coordinate positions - it will do it for you but at a cost.  If you do know them,
 * call makeTrackPcaFromLocalPoints instead.
 */
function makeTrackPca(track, trackPoint, pointIndex, referencePoint) {
    var localTrackPoint = Projection_1.Projection.current.toLocalCoordinates(new Position_1.Position(trackPoint.lat, trackPoint.lon, trackPoint.alt));
    var localReferencePoint = Projection_1.Projection.current.toLocalCoordinates(referencePoint);
    return makeTrackPcaFromLocalPoints(track, trackPoint, localTrackPoint, pointIndex, referencePoint, localReferencePoint);
}
/**
 * Creates a track pca object from a track, track point, point index and reference point.
 * Call this method where you know the local coordinate positions of the track point and the reference point, to save them needing to be calculated again.
 */
function makeTrackPcaFromLocalPoints(track, trackPoint, pointVector, pointIndex, referencePoint, referenceVector) {
    var deltaVector = pointVector.subtract(referenceVector);
    // Slant distance is the length of the delta vector, horizontal distance is the length with the Z component
    // taken out, and the angle of elevation uses the arc cos of the two sides of this right-angle triangle to
    // figure it out.
    var horizontalDistance = new Vector3_1.Vector3(pointVector.x, pointVector.y, 0).subtract(new Vector3_1.Vector3(referenceVector.x, referenceVector.y, 0)).length();
    var slantDistance = deltaVector.length();
    var elevationAngle = slantDistance == 0 ? 0 : Math3D.toDegrees(Math.acos(horizontalDistance / slantDistance));
    var pca = new TrackPca();
    pca.operationId = track.id;
    pca.referencePosition = referencePoint;
    pca.time = new Date(track.startTime.getTime() + (trackPoint.t * 1000));
    pca.trackPoint = trackPoint;
    pca.trackPointIndex = pointIndex;
    // Slant and Horizontal Distance are measured in meters
    pca.horizontalDistance = horizontalDistance;
    pca.slantDistance = slantDistance;
    // Vertical distance is measured in feet.
    pca.verticalDistance = trackPoint.alt - referencePoint.altitude;
    pca.elevationAngle = elevationAngle;
    return pca;
}
/**
 * From a line made up of Vector3 objects, gets the closest point on that line to a reference point.
 * This is copied from the C# Library.Spatial GetClosestPointToPoint(this Polyline polyline, Position point)
 */
function getClosestPointToPoint(polyline, point) {
    if (polyline == null || polyline.length == 0) {
        return -1;
    }
    var minDistance = Vector3_1.Vector3.distance(polyline[0], point);
    var minDistanceIndex = 0;
    for (var i = 0; i < polyline.length - 1; i++) {
        var closestPoint = Math3D.closestPointOnLineSegment(polyline[i], polyline[i + 1], point);
        var distance = Vector3_1.Vector3.distance(closestPoint.point, point);
        if (distance < minDistance) {
            minDistance = distance;
            minDistanceIndex = i + closestPoint.ratio;
        }
    }
    return minDistanceIndex;
}
function getPointAt(polyline, index) {
    var indexBefore = Math.floor(index);
    var indexAfter = Math.ceil(index);
    if (indexBefore == indexAfter) {
        return polyline[indexBefore];
    }
    else if (indexBefore < 0) {
        return polyline[0];
    }
    else if (indexAfter > polyline.length - 1) {
        return polyline[polyline.length - 1];
    }
    else {
        var pointBefore = polyline[indexBefore];
        var pointAfter = polyline[indexAfter];
        return Vector3_1.Vector3.lerp(pointBefore, pointAfter, index - indexBefore);
    }
}
//# sourceMappingURL=PcaAlgorithm.js.map